export default {
  defaultMessage: "Es ist ein Fehler aufgetreten.",
};
